const blockedPropertyIds = [
  3000080, //3Eleven
  3000043, //Goodwin Sales
  3000041, //Goodwin Marketing
  3000051, //Blue Skyline
  3000063, //4990 Las Vegas
]

export function isBlockedAnalyticsProperty(propertyId) {
  console.log({ propertyId })
  return blockedPropertyIds.includes(Number(propertyId))
}
